import React, { useState } from 'react';

import { faInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faEllipsisV } from '@fortawesome/pro-regular-svg-icons/faEllipsisV';
import { faMoneyCheckEditAlt } from '@fortawesome/pro-regular-svg-icons/faMoneyCheckEditAlt';
import { faStethoscope } from '@fortawesome/pro-regular-svg-icons/faStethoscope';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';

import { Resource } from '../constants/resource';
import { IKeyValMap } from '../interfaces/IKeyValMap';
import styles from './styles.module.scss';

export const Kebab = ({ options }: { options: IKeyValMap[] | null }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedOption, setSelectedOption] = React.useState(
    null as IKeyValMap | null,
  );

  const handleClick = (evt: React.MouseEvent<any>) => {
    setAnchorEl(evt.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogOpen = (option: IKeyValMap) => {
    // Needed for external actions, e.g., opening decision drawer
    if (option.onClick && typeof option.onClick === 'function') {
      option.onClick();
      handleClose();
      return;
    }

    setSelectedOption(option);
    handleClose();
  };

  const handleDialogClose = () => {
    setSelectedOption(null);
  };

  if (!options || !options.length) {
    return null;
  }

  return (
    <Box>
      <IconButton className={styles.KebabButton} onClick={handleClick}>
        <FontAwesomeIcon icon={faEllipsisV} className={styles.KebabIcon} />
      </IconButton>

      <Menu
        id="kebab-menu-btn"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {options.map((option, idx) => {
          return (
            <MenuItem key={idx} onClick={() => handleDialogOpen(option)}>
              <Typography variant="body2" color="textSecondary">
                {option.name}
              </Typography>
            </MenuItem>
          );
        })}
      </Menu>

      <Dialog
        open={Boolean(selectedOption)}
        onClose={handleDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {selectedOption?.name}
        </DialogTitle>
        <DialogContent>
          <Box mb={1}>
            {selectedOption &&
              Object.keys(selectedOption as object).map((key, idx) => {
                if (key === 'name') {
                  return null;
                }

                const value = selectedOption?.[key];

                return (
                  <Box my={1} key={idx}>
                    {key === 'description' ? (
                      <Typography variant="body2" color="textPrimary" paragraph>
                        <FontAwesomeIcon
                          icon={
                            selectedOption?.name === Resource.DOC_INFO_TITLE
                              ? faStethoscope
                              : selectedOption?.name ===
                                  Resource.AMENDMENT_TITLE
                                ? faMoneyCheckEditAlt
                                : faInfoCircle
                          }
                          style={{ marginRight: '1rem' }}
                        />
                        {value}
                      </Typography>
                    ) : key === 'reasons' ? (
                      value.map((reason: string) => (
                        <Typography
                          variant="body2"
                          color="textPrimary"
                          paragraph
                          key={reason}
                        >
                          <FontAwesomeIcon
                            icon={faCheck}
                            style={{ marginRight: '1rem' }}
                          />
                          {reason}
                        </Typography>
                      ))
                    ) : key === 'riders' ? (
                      value.map((rider: string) => (
                        <Typography
                          variant="body2"
                          color="textPrimary"
                          paragraph
                          key={rider}
                        >
                          <FontAwesomeIcon
                            icon={faCircle}
                            style={{
                              marginRight: '1rem',
                              fontSize: '0.3rem',
                              verticalAlign: 'middle',
                            }}
                          />
                          {rider}
                        </Typography>
                      ))
                    ) : key === 'conditions' ? (
                      <Box>
                        {value?.length && (
                          <Box mt={4}>
                            <Typography
                              variant="subtitle1"
                              color="textSecondary"
                              gutterBottom
                            >
                              {selectedOption?.name === Resource.POSTPONE_TITLE
                                ? 'Postpone conditions'
                                : 'Decline conditions'}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="textPrimary"
                              paragraph
                            >
                              {value.join(', ')}
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    ) : (
                      <Typography variant="body2" color="textPrimary" paragraph>
                        {JSON.stringify(value)}
                      </Typography>
                    )}
                  </Box>
                );
              })}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};
